import { guestLoginService } from '@/page/etc/Login/GuestLogin/GuestLogin.service'

export const testUtils = (() => {
  const testUtils = {
    generateTestEncryptedData: async (id: string, password: string, key?: string) => {
      const encryptedData = await guestLoginService.generateTestEncryptedData(id, password, key)
      console.info(encryptedData)
    },
  }

  return {
    initialize: () => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      ;(window as any).testUtils = testUtils
    },
  }
})()
